// @flow
import { FORM_INITIALIZE, RECEIVED_CONTACTS, RECEIVED_SERVER_ERRORS, SAVE_CONTACTS, SAVED_CONTACTS } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

export default handleActions(
    {
        // $FlowFixMe
        [RECEIVED_SERVER_ERRORS]: handleReduce((state, { payload }) => state.set('server_errors', payload)),
        // $FlowFixMe
        [FORM_INITIALIZE]: handleReduce(state => state.set('loading', false)),
        // $FlowFixMe
        [SAVE_CONTACTS]: handleReduce(state => state.merge({ saving: true, hasError: false })),
        [SAVED_CONTACTS]: handleReduce(
            (state, { payload: { addedContacts = [], updatedContacts = [] } }) =>
                // $FlowFixMe
                state.set('contacts', fromJS([...updatedContacts, ...addedContacts])).set('saving', false),
            // $FlowFixMe
            state => state.merge({ saving: false, hasError: true })
        ),
        [RECEIVED_CONTACTS]: handleReduce((state, { payload }) =>
            // $FlowFixMe
            state.set('loading', false).set('contacts', fromJS(payload))
        )
    },
    fromJS({
        saving: false,
        loading: true,
        hasError: false,
        contacts: []
    })
);



// WEBPACK FOOTER //
// ./src/core/state/text-control/index.js